import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import * as Material from 'babylonjs-materials';
import { Dfy, Battery, Zhy } from './probe';
// import { baseUrl } from '../url';
//import * as OIMO from 'oimo';
export default class Game{
    //初始化引擎
    constructor(canvasId){
        this.canvas = document.getElementById(canvasId);
        this.engine = new BABYLON.Engine(this.canvas, true,{ preserveDrawingBuffer: true, stencil: true });
        this.lodingScreen = new CustomLoadingScreen();
        this.engine.loadingScreen = this.lodingScreen;
        // Create the scene.
        this.scene=this.wellcomeScene();
        //this.dbHandler = new DBHandler();
        //this.scene=this.testDfyScene();
        //this.scene=this.testScene(this.engine,this.canvas);
        this.doRender();
    }
    //首页场景
    wellcomeScene(){
        this.engine.isPointerLock=true;
        var scene = new BABYLON.Scene(this.engine);
        scene.clearColor = new BABYLON.Color3(0.54, 0.70, 0.97);

        //var camera = new BABYLON.FreeCamera("camera1", new BABYLON.Vector3(0, 0, 0), scene);
        var camera=new BABYLON.ArcRotateCamera("Camera0", 3 * Math.PI / 2, 0.5, 20,  new BABYLON.Vector3(0,0,0),scene);
        var light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 0.7, 0), scene);
        
        light.intensity = 0.7;

        var Material = new BABYLON.StandardMaterial("material", scene);
        Material.diffuseColor = new BABYLON.Color3(0.5, 0.5, 0.5);
        Material.disableLighting = true;
        Material.emissiveColor = new BABYLON.Color3(0.73,0.88,0.77);
        BABYLON.Database.IDBStorageEnabled = true;
        BABYLON.SceneLoader.ImportMesh("", "./assets/models/", "earth.obj", scene, 
            (result)=> {    
                //camera.setTarget(result[0]);
                result[0].material=Material; 
                camera.attachControl(this.canvas,true); 
                //result[0].scaling=new BABYLON.Vector3(0.1,0.1,0.1)     
            }
        );
        return scene;
    }
    wellcomeScene2(){
        this.engine.isPointerLock=true;
        var scene = new BABYLON.Scene(this.engine);
        var camera = new BABYLON.ArcRotateCamera("Camera", -Math.PI / 2,  Math.PI / 2, 5, BABYLON.Vector3.Zero(), scene);
        camera.attachControl(this.canvas, true);
        
        var light = new BABYLON.HemisphericLight("hemiLight", new BABYLON.Vector3(-1, 1, 0), scene);
        light.diffuse = new BABYLON.Color3(1, 0, 0);
        
        // Skybox
        var skybox = BABYLON.MeshBuilder.CreateBox("skyBox", {size:1000.0}, scene);
        var skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
        skyboxMaterial.backFaceCulling = false;
        skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture("%PUBLIC_URL%/assets/skybox/skybox", scene);
        skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
        skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
        skybox.material = skyboxMaterial;			
            
        return scene;
    }
    //工作场景
    createScene(){
        var scene = new BABYLON.Scene(this.engine);
        scene.clearColor = new BABYLON.Color3(1, 1, 1); 
        this.engine.isPointerLock=false;
        this.engine.loadingScreen = this.lodingScreen;
        this.scene.collisionsEnabled = true;
        //var gravityVector = new BABYLON.Vector3(0,-9.81, 0);
        //var physicsPlugin = new BABYLON.AmmoJSPlugin();
        //scene.enablePhysics(null, physicsPlugin);
        var light=new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(1, 1, 1), scene);
        //scene.debugLayer.show();
        return scene;
    }

    //电法仪测试场景
    testDfyScene(){
        var scene = new BABYLON.Scene(this.engine);
        scene.clearColor = new BABYLON.Color3(1, 1, 1); 
        this.engine.isPointerLock=false;
        this.engine.loadingScreen = this.lodingScreen;
        //var gravityVector = new BABYLON.Vector3(0,-9.81, 0);
        //var physicsPlugin = new BABYLON.AmmoJSPlugin();
        //scene.enablePhysics(null, physicsPlugin);
        var light=new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(1, 1, 1), scene);
        var camera=new BABYLON.ArcRotateCamera("Camera0", 3 * Math.PI / 2, 0.5, 10,  new BABYLON.Vector3(0,0,0),scene);
        camera.attachControl(this.canvas,true);
        this.genernateDFY(scene,new BABYLON.Vector3(0,0,0),camera);
        scene.debugLayer.show();
        return scene;
    }
    fakeGeoScene(){
        var scene = new BABYLON.Scene(this.engine);
        scene.clearColor = new BABYLON.Color3(1, 1, 1); 
        this.engine.isPointerLock=false;
        this.engine.loadingScreen = this.lodingScreen;
        this.scene.collisionsEnabled = true;
        //var gravityVector = new BABYLON.Vector3(0,-9.81, 0);
        //var physicsPlugin = new BABYLON.AmmoJSPlugin();
        //scene.enablePhysics(null, physicsPlugin);
        var light=new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(1, 1, 1), scene);
        scene.debugLayer.show();
        let skyMaterial = new Material.SkyMaterial("skyMaterial", this.scene);
        skyMaterial.backFaceCulling = false;
        let skybox = BABYLON.Mesh.CreateBox("skyBox", Math.abs(1000)*10, this.scene);
        skybox.isPickable = false;
        skybox.material = skyMaterial;
        skyMaterial.inclination=0;
        var camera = new BABYLON.ArcRotateCamera("MainCamera", 3 * Math.PI / 2, 0.5, 20,  new BABYLON.Vector3(100,100,100), scene);
        BABYLON.SceneLoader.Append("./assets/models/", "fakeGeo.glb", scene, (scene)=> {
            // do something with the scene

        });

        return scene;
    }
    genernateDFY(scene,pos,camera){
        let dfy=new Dfy(scene,1,new BABYLON.Vector3(-6,0,0));
        var zhy=new Zhy(scene,1,new BABYLON.Vector3(6,0,0));
        var battery=new Battery(scene,1,new BABYLON.Vector3(-13,0,0));
        //battery.mesh.rotationQuaternion =new BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0,1,0),-Math.PI/2);
        var equitment=new BABYLON.MeshBuilder.CreateBox("equitment",{size:0.1},scene);
        equitment.isVisible=false;
        dfy.mesh.parent=equitment;
        zhy.mesh.parent=equitment;
        battery.mesh.parent=equitment;

        this.dfy=dfy;
        camera.target = dfy.screen.mesh;
        equitment.position=pos;
        //eleall
        dfy.eleall = [dfy.plusA,dfy.plusB,dfy.plusM,dfy.plusN,zhy.plusA,zhy.plusB,zhy.plusM,zhy.plusN,dfy.plus,dfy.minus,battery.plus,battery.minus];

        dfy.screen.activeControlPad2();
        
    }
    ////////////////

    
    //删除场景
    disposeScene(){
        this.scene.dispose();
        this.scene = this.createScene();

        //show debug layer
        //this.scene.debugLayer.show();
    }
    //渲染循环
    doRender() {
        // Run the render loop.
        this.engine.runRenderLoop(() => {
          this.scene.render();
        });
    
        // The canvas/window resize event handler.
        window.addEventListener('resize', () => {
            this.engine.resize();
        });
    }


    
}
//加载界面
class CustomLoadingScreen extends BABYLON.DefaultLoadingScreen{
    constructor(){
        super();
        //this.displayLoadingUI = this.displayLoadingUI.bind(this);
    }
    displayLoadingUI(){
        if (document.getElementById("customLoadingScreenDiv")) {
            document.getElementById("customLoadingScreenDiv").style.display = "initial";
            //console.log(document.getElementById("customLoadingScreenDiv").style.display);
            return;
        }
        this._loadingDiv = document.createElement("div");
        this._loadingDiv.id = "customLoadingScreenDiv";
        this._loadingDiv.innerHTML = "<br/><br/>正在努力加载中，请稍等...";
        var customLoadingScreenCss = document.createElement('style');
        customLoadingScreenCss.type = 'text/css';
        customLoadingScreenCss.innerHTML = `
        #customLoadingScreenDiv{
            background-color: #BB464Bcc;
            color: white;
            font-size:50px;
            text-align:center;
            z-index:99;
            width:100%;
            height:100%;
            position: absolute;
        }
        `;
        document.getElementsByTagName('head')[0].appendChild(customLoadingScreenCss);
        //this._resizeLoadingUI();
        //window.addEventListener("resize", this._resizeLoadingUI);
        document.body.appendChild(this._loadingDiv);
    }
    hideLoadingUI(){
        document.getElementById("customLoadingScreenDiv").style.display = "none";
    }
}